import { useInfiniteQuery, useQuery } from 'react-query'
import axios from 'lib/axiosConfig'
import { CountryCode } from 'types/api/country'
import { selectLanguageInCodeList } from 'lib/utils'
import { useEffect } from 'react'

export const useCountries = () => {
  const { data, hasNextPage, isFetchingNextPage, fetchNextPage, isFetching } =
    useInfiniteQuery(
      ['getCountries'],
      async ({ pageParam = 1 }) => {
        const { data } = await axios.get('/v1/countries', {
          params: { page: pageParam, page_size: 100 },
        })

        return {
          meta: data.meta,
          countries: data?.data,
        }
      },
      { getNextPageParam: (lastPage) => lastPage.meta.pagination.nextPage }
    )
  useEffect(() => {
    if (hasNextPage && !isFetchingNextPage) {
      fetchNextPage()
    }
  }, [hasNextPage, isFetchingNextPage])

  const allPages = data?.pages.flatMap((data) => data.countries) || []

  const countries =
    allPages && allPages?.length > 0 ? allPages.flatMap((data) => data) : []

  const loading = isFetching || hasNextPage
  return { loading, countries }
}

export const useCountryCodes = () => {
  const {
    isLoading: countryCodesLoading,
    error: countryCodesError,
    data: response,
  } = useQuery(
    ['getCountryCodes'],
    async () => axios.get('/v1/code-lists/countryCode'),
    {
      keepPreviousData: true,
    }
  )
  const countryCodes = response
    ? response.data.data.codeListRecord
        .map((code: CountryCode) => {
          const labelInLang = selectLanguageInCodeList(code.name)
          return {
            value: code.code,
            label: labelInLang?.$ ?? code.code,
          }
        })
        .sort(
          (
            a: { value: string; label: string },
            b: { value: string; label: string }
          ) => (a.label > b.label ? 1 : -1)
        )
        // include only options available for selectedLanguage
        .filter(
          (country: { value: string; label: string }) => country.label !== ''
        )
    : []

  return { countryCodes, countryCodesError, countryCodesLoading }
}
